module.exports = __webpack_public_path__ + "static/media/conical-sym.853269ea.png";